import React, { createContext, useContext, useState, useEffect } from "react";

const translations = {
  it: {
    // Navigation
    nav_login: "Accedi", nav_logout: "Esci", nav_dashboard: "Dashboard",
    nav_account: "Il mio account", nav_wishlist: "Lista desideri", nav_cart: "Carrello",
    nav_search: "Cerca", nav_orders: "Ordini", nav_settings: "Impostazioni",
    nav_back: "Indietro", nav_close: "Chiudi", nav_home: "Home", nav_contact: "Contatti",
    nav_about: "Chi siamo",

    // Common actions
    action_save: "Salva", action_cancel: "Annulla", action_delete: "Elimina",
    action_edit: "Modifica", action_create: "Crea", action_add: "Aggiungi",
    action_remove: "Rimuovi", action_confirm: "Conferma", action_submit: "Invia",
    action_continue: "Continua", action_back: "Indietro", action_next: "Avanti",
    action_view: "Visualizza", action_close: "Chiudi", action_apply: "Applica",
    action_filter: "Filtra", action_sort: "Ordina", action_reset: "Reimposta",
    action_load_more: "Carica altri", action_share: "Condividi",
    action_select: "Seleziona", action_download: "Scarica", action_upload: "Carica",

    // Status
    saved: "Salvato", error: "Errore", loading: "Caricamento...", success: "Operazione riuscita",
    empty: "Vuoto", all: "Tutti", none: "Nessuno", active: "Attivo", inactive: "Disattivo",
    enabled: "Abilitato", disabled: "Disabilitato", pending: "In attesa",
    approved: "Approvato", rejected: "Rifiutato",

    // Landing
    landing_eyebrow: "TotalKlick SRLS — Distribution Hub",
    landing_h1: "Una sola piattaforma. N reti di distribuzione.",
    landing_lead: "TotalKlick Hub orchestra reti multi-tenant in qualsiasi vertical: arredamento, moda, elettronica, food. Casa Madre, Rivenditori e Clienti — un'unica architettura whitelabel scalabile.",
    landing_cta_demo: "Esplora le vetrine demo",
    landing_cta_login: "Accedi alla piattaforma",
    landing_networks_title: "Le reti attive sul Hub",
    landing_networks_lead: "Ogni network ospita una propria Casa Madre, terminologia, campi prodotto e identità grafica. Configurazione in 5-10 minuti.",
    landing_features_title: "Architettura platform-of-platforms",
    feature_multi_network: "Multi-Network nativo",
    feature_multi_network_desc: "N reti di mercato indipendenti in un solo codebase. Switcher network nel SuperAdmin.",
    feature_vertical: "Vertical-driven config",
    feature_vertical_desc: "Terminologia, campi prodotto e status di disponibilità configurabili per ogni rete.",
    feature_sso: "SSO TotalKlick",
    feature_sso_desc: "Un solo login per Andrea e gli admin holding. RS256, verifica server-to-server.",
    feature_storefront: "Vetrine premium",
    feature_storefront_desc: "Ogni Rivenditore ha brand kit, dominio custom e CMS modulare con override gerarchico.",
    storefront_explore: "Esplora vetrina",
    rivenditori: "rivenditori", prodotti: "prodotti",

    // Login
    login_title: "Accedi a TotalKlick Hub",
    login_sso_btn: "Accedi con TotalKlick",
    login_sso_desc: "Single Sign-On sicuro · RS256 · verifica server-to-server",
    login_or: "oppure con email",
    login_email: "Email", login_password: "Password", login_submit: "Entra",
    login_demo_title: "Credenziali demo",
    login_no_account: "Non hai un account?", login_register: "Registrati",
    login_forgot: "Password dimenticata?",
    register_title: "Crea il tuo account",
    register_name: "Nome completo", register_submit: "Crea account",
    register_have_account: "Hai già un account?",

    // SuperAdmin
    sa_overview: "Panoramica", sa_networks: "Networks", sa_audit: "Audit log",
    sa_users: "Utenti", sa_customers: "Clienti centralizzati", sa_analytics: "Analytics",
    sa_total_networks: "Reti gestite", sa_total_tenants: "Tenant totali",
    sa_total_casa_madre: "Case Madre", sa_total_rivenditori: "Rivenditori",
    sa_total_prodotti: "Prodotti master", sa_total_ordini: "Ordini totali",
    sa_create_network: "Nuova network", sa_network_key: "Network key",
    sa_network_name: "Nome", sa_network_display: "Display name",
    sa_network_domain: "Dominio principale", sa_template: "Template vertical",
    sa_create_btn: "Crea network", sa_vertical_config: "Configurazione vertical",
    sa_terminology: "Terminologia", sa_statuses: "Status disponibilità",
    sa_custom_fields_v: "Campi custom variante", sa_categories: "Categorie",
    sa_impersonate: "Impersona", sa_open: "Apri",

    // Casa Madre
    cm_dashboard: "Dashboard Casa Madre", cm_products: "Catalogo prodotti",
    cm_new_product: "Nuovo prodotto",
    cm_no_products: "Nessun prodotto ancora — crea il primo",
    cm_orders: "Ordini B2B", cm_crm: "CRM conto terzi",
    cm_external_brands: "Brand esterni", cm_cms: "CMS vetrina",
    cm_storefront_catalog: "Vetrina catalogo", cm_csv_import: "Import CSV",
    cm_settings: "Impostazioni", cm_configure_variants: "Configura assi & varianti",
    cm_variant_axes: "Assi varianti", cm_variant_matrix: "Matrice combinazioni",
    cm_active_variants: "Varianti attive",

    // Rivenditore
    riv_dashboard: "Dashboard Rivenditore", riv_catalog: "Catalogo della vetrina",
    riv_visible: "Visibile", riv_price: "Prezzo (€)", riv_discount: "Sconto %",
    riv_save: "Salva", riv_view_storefront: "Vedi vetrina pubblica",
    riv_external_products: "Prodotti complementari", riv_orders: "Ordini & Tracking",
    riv_stock: "Stock", riv_status: "Stato disponibilità",

    // Storefront / Customer-facing
    store_view_product: "Vedi dettagli", store_add_cart: "Aggiungi al carrello",
    store_added_cart: "Aggiunto al carrello", store_buy_now: "Acquista ora",
    store_eta: "Consegna stimata", store_back: "Torna alla vetrina",
    store_specs: "Specifiche", store_warranty: "Garanzia", store_lead_time: "Tempi di consegna",
    store_categories: "Categorie", store_all: "Tutti",
    store_explore_collection: "Esplora la collezione",
    store_our_collection: "La nostra collezione",
    store_bestsellers: "I più amati",
    store_new_arrivals: "Nuovi arrivi",
    store_filter_category: "Filtra per categoria",
    store_results: "risultati",
    store_no_results: "Nessun prodotto trovato",
    store_search_placeholder: "Cerca prodotti, categorie, colori...",
    store_share: "Condividi", store_wishlist_add: "Aggiungi ai desideri",
    store_wishlist_remove: "Rimuovi dai desideri",
    store_reviews: "Recensioni", store_write_review: "Scrivi una recensione",
    store_no_reviews: "Nessuna recensione ancora",
    store_rating_avg: "Valutazione media",
    store_in_stock: "in pronta consegna",
    store_in_stock_one: "pezzo disponibile",
    store_in_stock_many: "pezzi disponibili",
    store_preorder: "Solo su prenotazione",
    store_preorder_days: "consegna in ~{n} giorni",
    store_continue_shopping: "Continua lo shopping",
    store_proceed_checkout: "Vai al checkout",
    store_quantity: "Quantità",
    store_recommended: "Ti potrebbero interessare",
    store_made_in: "Realizzato in",
    store_powered_by: "Powered by",
    store_about_us: "Chi siamo",
    store_customer_service: "Assistenza clienti",
    store_shop: "Shop", store_collection: "Collezione",
    store_manifesto: "Manifesto", store_newsletter_title: "Rimaniamo in contatto",
    store_newsletter_lead: "Anteprime delle nuove collezioni, eventi privati, riservato a chi si iscrive.",
    store_newsletter_email: "Il tuo indirizzo email",
    store_newsletter_subscribe: "Iscriviti",
    store_newsletter_consent: "Iscrivendoti accetti la nostra Privacy Policy.",
    store_newsletter_success: "Iscrizione confermata",

    // Cart / Checkout
    cart_title: "Il tuo carrello",
    cart_empty: "Il tuo carrello è vuoto",
    cart_subtotal: "Subtotale", cart_shipping: "Spedizione", cart_tax: "IVA",
    cart_total: "Totale", cart_item: "articolo", cart_items: "articoli",
    cart_remove_item: "Rimuovi", cart_update_qty: "Aggiorna quantità",
    cart_continue: "Continua lo shopping", cart_checkout: "Vai al checkout",
    cart_qty_in_stock: "in pronta consegna",
    cart_qty_preorder: "su prenotazione",
    checkout_title: "Checkout",
    checkout_shipping_address: "Indirizzo di spedizione",
    checkout_billing_address: "Indirizzo di fatturazione",
    checkout_payment: "Pagamento",
    checkout_review: "Riepilogo ordine",
    checkout_place_order: "Conferma e paga",
    checkout_first_name: "Nome", checkout_last_name: "Cognome",
    checkout_email: "Email", checkout_phone: "Telefono",
    checkout_address: "Indirizzo", checkout_city: "Città",
    checkout_zip: "CAP", checkout_country: "Paese", checkout_province: "Provincia",
    checkout_notes: "Note all'ordine (opzionali)",
    checkout_payment_method: "Metodo di pagamento",
    checkout_order_confirmed: "Ordine confermato",
    checkout_order_number: "Numero ordine",

    // Configurator
    config_title: "Configura il prodotto",
    config_unavailable: "Questa combinazione non è disponibile al momento. Prova a cambiare un'opzione.",
    config_save_link: "Salva configurazione",

    // Customer account
    account_title: "Il mio account", account_profile: "Profilo",
    account_orders: "I miei ordini", account_wishlist: "Lista desideri",
    account_addresses: "Indirizzi", account_password: "Cambia password",
    account_logout: "Esci",

    // Wishlist
    wishlist_empty: "La tua lista desideri è vuota",
    wishlist_added: "Aggiunto alla lista desideri",
    wishlist_removed: "Rimosso dalla lista desideri",

    // Editorial / Editorial Luxe storefront templates
    store_catalog: "Catalogo",
    store_catalog_title: "Catalogo prodotti",
    store_collection_2026: "Collezione 2026 · Made in Italy · Su misura",
    store_follow_us: "Seguici",
    store_highlight: "In evidenza",
    store_legal: "Note legali",
    store_legal_terms: "Termini legali",
    store_luxe_h2_a: "L'eleganza",
    store_luxe_h2_b: "del fatto a mano.",
    store_luxe_p1: "Ogni pezzo {brand} nasce da una collaborazione tra designer, artigiani e materie prime selezionate. Lavoriamo solo con legni certificati, tessuti naturali, finiture eseguite a mano.",
    store_luxe_p2: "Una tradizione italiana trasformata in linguaggio contemporaneo, per chi cerca arredi che durino nel tempo.",
    store_pillar_consult: "Consulenza personalizzata",
    store_pillar_design: "Progettazione su misura",
    store_pillar_delivery: "Consegna e montaggio professionale",
    store_pillar_support: "Assistenza post-vendita",
    store_price: "Prezzo",
    store_scenes_title: "Ambientazioni",
    store_scenes_subtitle: "Scopri le collezioni per ogni ambiente della tua casa.",
    store_service: "Servizio",
    store_terms_conditions: "Termini & Condizioni",
    store_made_in_italy: "Made in Italy",
    store_hero_default_subtitle: "Arredi di qualità, selezionati per te.",
    store_footer_default: "Arredi di qualità, Made in Italy.",
    store_months: "mesi",
    store_days: "giorni",
  },

  en: {
    nav_login: "Login", nav_logout: "Logout", nav_dashboard: "Dashboard",
    nav_account: "My account", nav_wishlist: "Wishlist", nav_cart: "Cart",
    nav_search: "Search", nav_orders: "Orders", nav_settings: "Settings",
    nav_back: "Back", nav_close: "Close", nav_home: "Home", nav_contact: "Contact",
    nav_about: "About",
    action_save: "Save", action_cancel: "Cancel", action_delete: "Delete",
    action_edit: "Edit", action_create: "Create", action_add: "Add",
    action_remove: "Remove", action_confirm: "Confirm", action_submit: "Submit",
    action_continue: "Continue", action_back: "Back", action_next: "Next",
    action_view: "View", action_close: "Close", action_apply: "Apply",
    action_filter: "Filter", action_sort: "Sort", action_reset: "Reset",
    action_load_more: "Load more", action_share: "Share",
    action_select: "Select", action_download: "Download", action_upload: "Upload",
    saved: "Saved", error: "Error", loading: "Loading...", success: "Success",
    empty: "Empty", all: "All", none: "None", active: "Active", inactive: "Inactive",
    enabled: "Enabled", disabled: "Disabled", pending: "Pending",
    approved: "Approved", rejected: "Rejected",
    landing_eyebrow: "TotalKlick SRLS — Distribution Hub",
    landing_h1: "One platform. N distribution networks.",
    landing_lead: "TotalKlick Hub orchestrates multi-tenant networks across any vertical: furniture, fashion, electronics, food. Casa Madre, Retailers and Customers — one whitelabel scalable architecture.",
    landing_cta_demo: "Explore demo storefronts", landing_cta_login: "Access the platform",
    landing_networks_title: "Active networks on the Hub",
    landing_networks_lead: "Each network hosts its own Casa Madre, terminology, product fields and brand identity. 5-10 min setup.",
    landing_features_title: "Platform-of-platforms architecture",
    feature_multi_network: "Native multi-network",
    feature_multi_network_desc: "N independent market networks in one codebase. Network switcher in SuperAdmin.",
    feature_vertical: "Vertical-driven config",
    feature_vertical_desc: "Terminology, product fields and availability statuses configurable per network.",
    feature_sso: "TotalKlick SSO",
    feature_sso_desc: "Single login for Andrea and holding admins. RS256, server-to-server verify.",
    feature_storefront: "Premium storefronts",
    feature_storefront_desc: "Each retailer has brand kit, custom domain and modular CMS with hierarchical override.",
    storefront_explore: "Explore storefront",
    rivenditori: "retailers", prodotti: "products",
    login_title: "Sign in to TotalKlick Hub", login_sso_btn: "Sign in with TotalKlick",
    login_sso_desc: "Secure SSO · RS256 · server-to-server verify", login_or: "or with email",
    login_email: "Email", login_password: "Password", login_submit: "Sign in",
    login_demo_title: "Demo credentials",
    login_no_account: "Don't have an account?", login_register: "Register",
    login_forgot: "Forgot password?",
    register_title: "Create your account", register_name: "Full name",
    register_submit: "Create account", register_have_account: "Already have an account?",
    sa_overview: "Overview", sa_networks: "Networks", sa_audit: "Audit log",
    sa_users: "Users", sa_customers: "Central customers", sa_analytics: "Analytics",
    sa_total_networks: "Networks managed", sa_total_tenants: "Total tenants",
    sa_total_casa_madre: "Casa Madre", sa_total_rivenditori: "Retailers",
    sa_total_prodotti: "Master products", sa_total_ordini: "Total orders",
    sa_create_network: "New network", sa_network_key: "Network key", sa_network_name: "Name",
    sa_network_display: "Display name", sa_network_domain: "Main domain",
    sa_template: "Vertical template", sa_create_btn: "Create network",
    sa_vertical_config: "Vertical configuration", sa_terminology: "Terminology",
    sa_statuses: "Availability statuses", sa_custom_fields_v: "Variant custom fields",
    sa_categories: "Categories", sa_impersonate: "Impersonate", sa_open: "Open",
    cm_dashboard: "Casa Madre Dashboard", cm_products: "Product catalog",
    cm_new_product: "New product", cm_no_products: "No products yet — create your first",
    cm_orders: "B2B Orders", cm_crm: "Third-party CRM",
    cm_external_brands: "External brands", cm_cms: "Storefront CMS",
    cm_storefront_catalog: "Storefront catalog", cm_csv_import: "CSV import",
    cm_settings: "Settings", cm_configure_variants: "Configure axes & variants",
    cm_variant_axes: "Variant axes", cm_variant_matrix: "Combinations matrix",
    cm_active_variants: "Active variants",
    riv_dashboard: "Retailer Dashboard", riv_catalog: "Storefront catalog",
    riv_visible: "Visible", riv_price: "Price (€)", riv_discount: "Discount %",
    riv_save: "Save", riv_view_storefront: "View public storefront",
    riv_external_products: "Complementary products", riv_orders: "Orders & Tracking",
    riv_stock: "Stock", riv_status: "Availability status",
    store_view_product: "View details", store_add_cart: "Add to cart",
    store_added_cart: "Added to cart", store_buy_now: "Buy now",
    store_eta: "Estimated delivery", store_back: "Back to storefront",
    store_specs: "Specs", store_warranty: "Warranty", store_lead_time: "Lead time",
    store_categories: "Categories", store_all: "All",
    store_explore_collection: "Explore the collection",
    store_our_collection: "Our collection",
    store_bestsellers: "Best sellers", store_new_arrivals: "New arrivals",
    store_filter_category: "Filter by category", store_results: "results",
    store_no_results: "No products found",
    store_search_placeholder: "Search products, categories, colors...",
    store_share: "Share", store_wishlist_add: "Add to wishlist",
    store_wishlist_remove: "Remove from wishlist",
    store_reviews: "Reviews", store_write_review: "Write a review",
    store_no_reviews: "No reviews yet", store_rating_avg: "Average rating",
    store_in_stock: "ready to ship", store_in_stock_one: "piece available",
    store_in_stock_many: "pieces available", store_preorder: "Pre-order only",
    store_preorder_days: "delivery in ~{n} days",
    store_continue_shopping: "Continue shopping", store_proceed_checkout: "Proceed to checkout",
    store_quantity: "Quantity", store_recommended: "You may also like",
    store_made_in: "Made in", store_powered_by: "Powered by",
    store_about_us: "About us", store_customer_service: "Customer service",
    store_shop: "Shop", store_collection: "Collection",
    store_manifesto: "Manifesto", store_newsletter_title: "Stay in touch",
    store_newsletter_lead: "Sneak peeks of new collections, private events, reserved for subscribers.",
    store_newsletter_email: "Your email address", store_newsletter_subscribe: "Subscribe",
    store_newsletter_consent: "By subscribing you accept our Privacy Policy.",
    store_newsletter_success: "Subscription confirmed",
    cart_title: "Your cart", cart_empty: "Your cart is empty",
    cart_subtotal: "Subtotal", cart_shipping: "Shipping", cart_tax: "VAT",
    cart_total: "Total", cart_item: "item", cart_items: "items",
    cart_remove_item: "Remove", cart_update_qty: "Update quantity",
    cart_continue: "Continue shopping", cart_checkout: "Proceed to checkout",
    cart_qty_in_stock: "in stock", cart_qty_preorder: "pre-order",
    checkout_title: "Checkout", checkout_shipping_address: "Shipping address",
    checkout_billing_address: "Billing address", checkout_payment: "Payment",
    checkout_review: "Order summary", checkout_place_order: "Confirm and pay",
    checkout_first_name: "First name", checkout_last_name: "Last name",
    checkout_email: "Email", checkout_phone: "Phone",
    checkout_address: "Address", checkout_city: "City",
    checkout_zip: "ZIP", checkout_country: "Country", checkout_province: "Province/State",
    checkout_notes: "Order notes (optional)", checkout_payment_method: "Payment method",
    checkout_order_confirmed: "Order confirmed", checkout_order_number: "Order number",
    config_title: "Configure your product",
    config_unavailable: "This combination is not available at the moment. Try changing an option.",
    config_save_link: "Save configuration",
    account_title: "My account", account_profile: "Profile",
    account_orders: "My orders", account_wishlist: "Wishlist",
    account_addresses: "Addresses", account_password: "Change password",
    account_logout: "Logout",
    wishlist_empty: "Your wishlist is empty",
    wishlist_added: "Added to wishlist", wishlist_removed: "Removed from wishlist",

    store_catalog: "Catalog",
    store_catalog_title: "Product catalog",
    store_collection_2026: "2026 Collection · Made in Italy · Bespoke",
    store_follow_us: "Follow us",
    store_highlight: "Highlight",
    store_legal: "Legal",
    store_legal_terms: "Legal terms",
    store_luxe_h2_a: "The elegance",
    store_luxe_h2_b: "of handcraft.",
    store_luxe_p1: "Every {brand} piece is born from a collaboration between designers, artisans and carefully selected raw materials. We work only with certified woods, natural fabrics and hand-finished detailing.",
    store_luxe_p2: "An Italian tradition translated into a contemporary language, for those seeking furniture that lasts through time.",
    store_pillar_consult: "Personalised consulting",
    store_pillar_design: "Bespoke design",
    store_pillar_delivery: "Professional delivery & assembly",
    store_pillar_support: "After-sales support",
    store_price: "Price",
    store_scenes_title: "Settings",
    store_scenes_subtitle: "Discover collections for every room of your home.",
    store_service: "Service",
    store_terms_conditions: "Terms & Conditions",
    store_made_in_italy: "Made in Italy",
    store_hero_default_subtitle: "Quality furniture, selected for you.",
    store_footer_default: "Quality furniture, Made in Italy.",
    store_months: "months",
    store_days: "days",
  },

  fr: {
    nav_login: "Connexion", nav_logout: "Quitter", nav_dashboard: "Tableau de bord",
    nav_account: "Mon compte", nav_wishlist: "Liste de souhaits", nav_cart: "Panier",
    nav_search: "Rechercher", nav_orders: "Commandes", nav_settings: "Paramètres",
    nav_back: "Retour", nav_close: "Fermer", nav_home: "Accueil", nav_contact: "Contact",
    nav_about: "À propos",
    action_save: "Enregistrer", action_cancel: "Annuler", action_delete: "Supprimer",
    action_edit: "Modifier", action_create: "Créer", action_add: "Ajouter",
    action_remove: "Retirer", action_confirm: "Confirmer", action_submit: "Envoyer",
    action_continue: "Continuer", action_back: "Retour", action_next: "Suivant",
    action_view: "Voir", action_close: "Fermer", action_apply: "Appliquer",
    action_filter: "Filtrer", action_sort: "Trier", action_reset: "Réinitialiser",
    action_load_more: "Voir plus", action_share: "Partager",
    action_select: "Sélectionner", action_download: "Télécharger", action_upload: "Téléverser",
    saved: "Enregistré", error: "Erreur", loading: "Chargement...", success: "Succès",
    empty: "Vide", all: "Tous", none: "Aucun", active: "Actif", inactive: "Inactif",
    enabled: "Activé", disabled: "Désactivé", pending: "En attente",
    approved: "Approuvé", rejected: "Refusé",
    landing_eyebrow: "TotalKlick SRLS — Distribution Hub",
    landing_h1: "Une plateforme. N réseaux de distribution.",
    landing_lead: "TotalKlick Hub orchestre des réseaux multi-tenant dans n'importe quel vertical : mobilier, mode, électronique, alimentation. Une architecture whitelabel scalable.",
    landing_cta_demo: "Découvrir les vitrines", landing_cta_login: "Accéder à la plateforme",
    landing_networks_title: "Réseaux actifs sur le Hub",
    landing_networks_lead: "Chaque réseau a sa propre Casa Madre, terminologie et identité.",
    landing_features_title: "Architecture platform-of-platforms",
    feature_multi_network: "Multi-réseau natif",
    feature_multi_network_desc: "N réseaux indépendants dans un même codebase.",
    feature_vertical: "Config par vertical",
    feature_vertical_desc: "Terminologie et champs configurables par réseau.",
    feature_sso: "SSO TotalKlick", feature_sso_desc: "Un seul login pour les admins. RS256.",
    feature_storefront: "Vitrines premium",
    feature_storefront_desc: "Brand kit, domaine custom, CMS modulaire.",
    storefront_explore: "Voir la vitrine", rivenditori: "revendeurs", prodotti: "produits",
    login_title: "Connectez-vous à TotalKlick Hub", login_sso_btn: "Se connecter avec TotalKlick",
    login_sso_desc: "SSO sécurisé · RS256", login_or: "ou par email",
    login_email: "Email", login_password: "Mot de passe", login_submit: "Entrer",
    login_demo_title: "Identifiants démo",
    login_no_account: "Vous n'avez pas de compte ?", login_register: "S'inscrire",
    login_forgot: "Mot de passe oublié ?",
    register_title: "Créez votre compte", register_name: "Nom complet",
    register_submit: "Créer le compte", register_have_account: "Vous avez déjà un compte ?",
    sa_overview: "Vue d'ensemble", sa_networks: "Réseaux", sa_audit: "Journal d'audit",
    sa_users: "Utilisateurs", sa_customers: "Clients centralisés", sa_analytics: "Analytique",
    sa_total_networks: "Réseaux gérés", sa_total_tenants: "Tenants total",
    sa_total_casa_madre: "Casa Madre", sa_total_rivenditori: "Revendeurs",
    sa_total_prodotti: "Produits master", sa_total_ordini: "Commandes totales",
    sa_create_network: "Nouveau réseau", sa_network_key: "Clé réseau", sa_network_name: "Nom",
    sa_network_display: "Nom affiché", sa_network_domain: "Domaine principal",
    sa_template: "Template vertical", sa_create_btn: "Créer le réseau",
    sa_vertical_config: "Configuration vertical", sa_terminology: "Terminologie",
    sa_statuses: "Statuts disponibilité", sa_custom_fields_v: "Champs variante",
    sa_categories: "Catégories", sa_impersonate: "Incarner", sa_open: "Ouvrir",
    cm_dashboard: "Tableau de bord Casa Madre", cm_products: "Catalogue",
    cm_new_product: "Nouveau produit", cm_no_products: "Aucun produit",
    cm_orders: "Commandes B2B", cm_crm: "CRM tiers",
    cm_external_brands: "Marques externes", cm_cms: "CMS vitrine",
    cm_storefront_catalog: "Catalogue vitrine", cm_csv_import: "Import CSV",
    cm_settings: "Paramètres", cm_configure_variants: "Configurer axes & variantes",
    cm_variant_axes: "Axes de variantes", cm_variant_matrix: "Matrice de combinaisons",
    cm_active_variants: "Variantes actives",
    riv_dashboard: "Tableau de bord Revendeur", riv_catalog: "Catalogue vitrine",
    riv_visible: "Visible", riv_price: "Prix (€)", riv_discount: "Remise %",
    riv_save: "Enregistrer", riv_view_storefront: "Voir la vitrine publique",
    riv_external_products: "Produits complémentaires", riv_orders: "Commandes & Suivi",
    riv_stock: "Stock", riv_status: "Statut de disponibilité",
    store_view_product: "Voir détails", store_add_cart: "Ajouter au panier",
    store_added_cart: "Ajouté au panier", store_buy_now: "Acheter maintenant",
    store_eta: "Livraison estimée", store_back: "Retour", store_specs: "Spécifications",
    store_warranty: "Garantie", store_lead_time: "Délai", store_categories: "Catégories",
    store_all: "Tous", store_explore_collection: "Découvrir la collection",
    store_our_collection: "Notre collection", store_bestsellers: "Best-sellers",
    store_new_arrivals: "Nouveautés", store_filter_category: "Filtrer par catégorie",
    store_results: "résultats", store_no_results: "Aucun produit trouvé",
    store_search_placeholder: "Rechercher produits, catégories, couleurs...",
    store_share: "Partager", store_wishlist_add: "Ajouter aux favoris",
    store_wishlist_remove: "Retirer des favoris", store_reviews: "Avis",
    store_write_review: "Écrire un avis", store_no_reviews: "Aucun avis encore",
    store_rating_avg: "Note moyenne", store_in_stock: "en stock",
    store_in_stock_one: "pièce disponible", store_in_stock_many: "pièces disponibles",
    store_preorder: "Uniquement sur précommande",
    store_preorder_days: "livraison en ~{n} jours",
    store_continue_shopping: "Continuer les achats",
    store_proceed_checkout: "Procéder au paiement",
    store_quantity: "Quantité", store_recommended: "Cela pourrait vous plaire",
    store_made_in: "Fabriqué en", store_powered_by: "Propulsé par",
    store_about_us: "À propos", store_customer_service: "Service client",
    store_shop: "Boutique", store_collection: "Collection",
    store_manifesto: "Manifeste", store_newsletter_title: "Restons en contact",
    store_newsletter_lead: "Avant-premières des nouvelles collections, événements privés, réservé aux abonnés.",
    store_newsletter_email: "Votre adresse email", store_newsletter_subscribe: "S'inscrire",
    store_newsletter_consent: "En vous inscrivant vous acceptez notre Politique de confidentialité.",
    store_newsletter_success: "Inscription confirmée",
    cart_title: "Votre panier", cart_empty: "Votre panier est vide",
    cart_subtotal: "Sous-total", cart_shipping: "Livraison", cart_tax: "TVA",
    cart_total: "Total", cart_item: "article", cart_items: "articles",
    cart_remove_item: "Retirer", cart_update_qty: "Mettre à jour la quantité",
    cart_continue: "Continuer les achats", cart_checkout: "Procéder au paiement",
    cart_qty_in_stock: "en stock", cart_qty_preorder: "précommande",
    checkout_title: "Paiement", checkout_shipping_address: "Adresse de livraison",
    checkout_billing_address: "Adresse de facturation", checkout_payment: "Paiement",
    checkout_review: "Résumé de commande", checkout_place_order: "Confirmer et payer",
    checkout_first_name: "Prénom", checkout_last_name: "Nom",
    checkout_email: "Email", checkout_phone: "Téléphone",
    checkout_address: "Adresse", checkout_city: "Ville",
    checkout_zip: "Code postal", checkout_country: "Pays", checkout_province: "Région/Département",
    checkout_notes: "Notes de commande (optionnelles)",
    checkout_payment_method: "Mode de paiement",
    checkout_order_confirmed: "Commande confirmée", checkout_order_number: "Numéro de commande",
    config_title: "Configurez votre produit",
    config_unavailable: "Cette combinaison n'est pas disponible. Essayez une autre option.",
    config_save_link: "Sauvegarder la configuration",
    account_title: "Mon compte", account_profile: "Profil",
    account_orders: "Mes commandes", account_wishlist: "Liste de souhaits",
    account_addresses: "Adresses", account_password: "Changer le mot de passe",
    account_logout: "Déconnexion",
    wishlist_empty: "Votre liste de souhaits est vide",
    wishlist_added: "Ajouté à la liste de souhaits",
    wishlist_removed: "Retiré de la liste de souhaits",

    store_catalog: "Catalogue",
    store_catalog_title: "Catalogue produits",
    store_collection_2026: "Collection 2026 · Made in Italy · Sur mesure",
    store_follow_us: "Suivez-nous",
    store_highlight: "Sélection",
    store_legal: "Mentions légales",
    store_legal_terms: "Mentions légales",
    store_luxe_h2_a: "L'élégance",
    store_luxe_h2_b: "du fait-main.",
    store_luxe_p1: "Chaque pièce {brand} naît d'une collaboration entre designers, artisans et matières premières sélectionnées. Nous travaillons uniquement avec des bois certifiés, des tissus naturels et des finitions exécutées à la main.",
    store_luxe_p2: "Une tradition italienne traduite en langage contemporain, pour ceux qui recherchent des meubles intemporels.",
    store_pillar_consult: "Conseil personnalisé",
    store_pillar_design: "Conception sur mesure",
    store_pillar_delivery: "Livraison et montage professionnels",
    store_pillar_support: "Service après-vente",
    store_price: "Prix",
    store_scenes_title: "Ambiances",
    store_scenes_subtitle: "Découvrez les collections pour chaque pièce de votre maison.",
    store_service: "Service",
    store_terms_conditions: "Conditions générales",
    store_made_in_italy: "Made in Italy",
    store_hero_default_subtitle: "Mobilier de qualité, sélectionné pour vous.",
    store_footer_default: "Mobilier de qualité, Made in Italy.",
    store_months: "mois",
    store_days: "jours",
  },

  de: {
    nav_login: "Anmelden", nav_logout: "Abmelden", nav_dashboard: "Dashboard",
    nav_account: "Mein Konto", nav_wishlist: "Wunschliste", nav_cart: "Warenkorb",
    nav_search: "Suchen", nav_orders: "Bestellungen", nav_settings: "Einstellungen",
    nav_back: "Zurück", nav_close: "Schließen", nav_home: "Home", nav_contact: "Kontakt",
    nav_about: "Über uns",
    action_save: "Speichern", action_cancel: "Abbrechen", action_delete: "Löschen",
    action_edit: "Bearbeiten", action_create: "Erstellen", action_add: "Hinzufügen",
    action_remove: "Entfernen", action_confirm: "Bestätigen", action_submit: "Senden",
    action_continue: "Weiter", action_back: "Zurück", action_next: "Weiter",
    action_view: "Ansehen", action_close: "Schließen", action_apply: "Anwenden",
    action_filter: "Filtern", action_sort: "Sortieren", action_reset: "Zurücksetzen",
    action_load_more: "Mehr laden", action_share: "Teilen",
    action_select: "Auswählen", action_download: "Herunterladen", action_upload: "Hochladen",
    saved: "Gespeichert", error: "Fehler", loading: "Lädt...", success: "Erfolg",
    empty: "Leer", all: "Alle", none: "Keine", active: "Aktiv", inactive: "Inaktiv",
    enabled: "Aktiviert", disabled: "Deaktiviert", pending: "Ausstehend",
    approved: "Genehmigt", rejected: "Abgelehnt",
    landing_eyebrow: "TotalKlick SRLS — Distribution Hub",
    landing_h1: "Eine Plattform. N Vertriebsnetze.",
    landing_lead: "TotalKlick Hub orchestriert Multi-Tenant-Netzwerke in jedem Vertical: Möbel, Mode, Elektronik, Food.",
    landing_cta_demo: "Demo-Storefronts entdecken", landing_cta_login: "Plattform betreten",
    landing_networks_title: "Aktive Netzwerke",
    landing_networks_lead: "Jedes Netzwerk hat eigene Casa Madre, Terminologie und Identität.",
    landing_features_title: "Platform-of-Platforms-Architektur",
    feature_multi_network: "Natives Multi-Netzwerk",
    feature_multi_network_desc: "N unabhängige Marktnetzwerke in einer Codebase.",
    feature_vertical: "Vertical-getriebene Konfig",
    feature_vertical_desc: "Terminologie und Felder pro Netzwerk konfigurierbar.",
    feature_sso: "TotalKlick SSO", feature_sso_desc: "Ein Login für alle Admins. RS256.",
    feature_storefront: "Premium Storefronts",
    feature_storefront_desc: "Brand Kit, Custom-Domain, modulares CMS.",
    storefront_explore: "Storefront ansehen", rivenditori: "Händler", prodotti: "Produkte",
    login_title: "Bei TotalKlick Hub anmelden", login_sso_btn: "Mit TotalKlick anmelden",
    login_sso_desc: "Sicheres SSO · RS256", login_or: "oder per E-Mail",
    login_email: "E-Mail", login_password: "Passwort", login_submit: "Anmelden",
    login_demo_title: "Demo-Zugangsdaten",
    login_no_account: "Noch kein Konto?", login_register: "Registrieren",
    login_forgot: "Passwort vergessen?",
    register_title: "Konto erstellen", register_name: "Vollständiger Name",
    register_submit: "Konto erstellen", register_have_account: "Bereits ein Konto?",
    sa_overview: "Übersicht", sa_networks: "Netzwerke", sa_audit: "Audit-Log",
    sa_users: "Benutzer", sa_customers: "Zentrale Kunden", sa_analytics: "Analytik",
    sa_total_networks: "Verwaltete Netzwerke", sa_total_tenants: "Tenants gesamt",
    sa_total_casa_madre: "Casa Madre", sa_total_rivenditori: "Händler",
    sa_total_prodotti: "Master-Produkte", sa_total_ordini: "Bestellungen gesamt",
    sa_create_network: "Neues Netzwerk", sa_network_key: "Netzwerk-Key", sa_network_name: "Name",
    sa_network_display: "Anzeigename", sa_network_domain: "Hauptdomain",
    sa_template: "Vertical-Template", sa_create_btn: "Netzwerk anlegen",
    sa_vertical_config: "Vertical-Konfiguration", sa_terminology: "Terminologie",
    sa_statuses: "Verfügbarkeits-Status", sa_custom_fields_v: "Varianten-Felder",
    sa_categories: "Kategorien", sa_impersonate: "Imitieren", sa_open: "Öffnen",
    cm_dashboard: "Casa Madre Dashboard", cm_products: "Produktkatalog",
    cm_new_product: "Neues Produkt", cm_no_products: "Keine Produkte",
    cm_orders: "B2B Bestellungen", cm_crm: "Drittanbieter-CRM",
    cm_external_brands: "Externe Marken", cm_cms: "Storefront CMS",
    cm_storefront_catalog: "Storefront-Katalog", cm_csv_import: "CSV-Import",
    cm_settings: "Einstellungen", cm_configure_variants: "Achsen & Varianten konfigurieren",
    cm_variant_axes: "Varianten-Achsen", cm_variant_matrix: "Kombinationsmatrix",
    cm_active_variants: "Aktive Varianten",
    riv_dashboard: "Händler Dashboard", riv_catalog: "Storefront-Katalog",
    riv_visible: "Sichtbar", riv_price: "Preis (€)", riv_discount: "Rabatt %",
    riv_save: "Speichern", riv_view_storefront: "Öffentlichen Storefront ansehen",
    riv_external_products: "Komplementärprodukte", riv_orders: "Bestellungen & Tracking",
    riv_stock: "Lager", riv_status: "Verfügbarkeitsstatus",
    store_view_product: "Details ansehen", store_add_cart: "In den Warenkorb",
    store_added_cart: "Zum Warenkorb hinzugefügt", store_buy_now: "Jetzt kaufen",
    store_eta: "Voraussichtliche Lieferung", store_back: "Zurück",
    store_specs: "Spezifikationen", store_warranty: "Garantie",
    store_lead_time: "Lieferzeit", store_categories: "Kategorien", store_all: "Alle",
    store_explore_collection: "Kollektion entdecken",
    store_our_collection: "Unsere Kollektion",
    store_bestsellers: "Beliebte Produkte", store_new_arrivals: "Neuheiten",
    store_filter_category: "Nach Kategorie filtern", store_results: "Ergebnisse",
    store_no_results: "Keine Produkte gefunden",
    store_search_placeholder: "Produkte, Kategorien, Farben suchen...",
    store_share: "Teilen", store_wishlist_add: "Zur Wunschliste",
    store_wishlist_remove: "Von Wunschliste entfernen",
    store_reviews: "Bewertungen", store_write_review: "Bewertung schreiben",
    store_no_reviews: "Noch keine Bewertungen", store_rating_avg: "Durchschnittsbewertung",
    store_in_stock: "auf Lager", store_in_stock_one: "Stück verfügbar",
    store_in_stock_many: "Stück verfügbar", store_preorder: "Nur auf Vorbestellung",
    store_preorder_days: "Lieferung in ~{n} Tagen",
    store_continue_shopping: "Weiter einkaufen", store_proceed_checkout: "Zur Kasse",
    store_quantity: "Menge", store_recommended: "Könnte Ihnen gefallen",
    store_made_in: "Hergestellt in", store_powered_by: "Powered by",
    store_about_us: "Über uns", store_customer_service: "Kundenservice",
    store_shop: "Shop", store_collection: "Kollektion",
    store_manifesto: "Manifest", store_newsletter_title: "In Kontakt bleiben",
    store_newsletter_lead: "Vorschauen neuer Kollektionen, private Events, nur für Abonnenten.",
    store_newsletter_email: "Ihre E-Mail-Adresse",
    store_newsletter_subscribe: "Abonnieren",
    store_newsletter_consent: "Mit der Anmeldung akzeptieren Sie unsere Datenschutzerklärung.",
    store_newsletter_success: "Anmeldung bestätigt",
    cart_title: "Ihr Warenkorb", cart_empty: "Ihr Warenkorb ist leer",
    cart_subtotal: "Zwischensumme", cart_shipping: "Versand", cart_tax: "MwSt.",
    cart_total: "Gesamt", cart_item: "Artikel", cart_items: "Artikel",
    cart_remove_item: "Entfernen", cart_update_qty: "Menge aktualisieren",
    cart_continue: "Weiter einkaufen", cart_checkout: "Zur Kasse",
    cart_qty_in_stock: "auf Lager", cart_qty_preorder: "Vorbestellung",
    checkout_title: "Kasse", checkout_shipping_address: "Lieferadresse",
    checkout_billing_address: "Rechnungsadresse", checkout_payment: "Zahlung",
    checkout_review: "Bestellübersicht", checkout_place_order: "Bestätigen und bezahlen",
    checkout_first_name: "Vorname", checkout_last_name: "Nachname",
    checkout_email: "E-Mail", checkout_phone: "Telefon",
    checkout_address: "Adresse", checkout_city: "Stadt",
    checkout_zip: "PLZ", checkout_country: "Land", checkout_province: "Bundesland",
    checkout_notes: "Bestellnotizen (optional)", checkout_payment_method: "Zahlungsmethode",
    checkout_order_confirmed: "Bestellung bestätigt",
    checkout_order_number: "Bestellnummer",
    config_title: "Produkt konfigurieren",
    config_unavailable: "Diese Kombination ist derzeit nicht verfügbar. Probieren Sie eine andere Option.",
    config_save_link: "Konfiguration speichern",
    account_title: "Mein Konto", account_profile: "Profil",
    account_orders: "Meine Bestellungen", account_wishlist: "Wunschliste",
    account_addresses: "Adressen", account_password: "Passwort ändern",
    account_logout: "Abmelden",
    wishlist_empty: "Ihre Wunschliste ist leer",
    wishlist_added: "Zur Wunschliste hinzugefügt",
    wishlist_removed: "Von der Wunschliste entfernt",

    store_catalog: "Katalog",
    store_catalog_title: "Produktkatalog",
    store_collection_2026: "Kollektion 2026 · Made in Italy · Maßgeschneidert",
    store_follow_us: "Folgen Sie uns",
    store_highlight: "Highlight",
    store_legal: "Rechtliches",
    store_legal_terms: "Rechtliche Hinweise",
    store_luxe_h2_a: "Die Eleganz",
    store_luxe_h2_b: "des Handwerks.",
    store_luxe_p1: "Jedes {brand}-Stück entsteht aus der Zusammenarbeit zwischen Designern, Handwerkern und sorgfältig ausgewählten Rohstoffen. Wir arbeiten ausschließlich mit zertifizierten Hölzern, Naturstoffen und handgearbeiteten Veredelungen.",
    store_luxe_p2: "Eine italienische Tradition, übersetzt in eine zeitgenössische Sprache — für Menschen, die zeitlose Möbel suchen.",
    store_pillar_consult: "Persönliche Beratung",
    store_pillar_design: "Maßgeschneidertes Design",
    store_pillar_delivery: "Professionelle Lieferung & Montage",
    store_pillar_support: "Kundendienst nach dem Kauf",
    store_price: "Preis",
    store_scenes_title: "Wohnwelten",
    store_scenes_subtitle: "Entdecken Sie Kollektionen für jeden Raum Ihres Zuhauses.",
    store_service: "Service",
    store_terms_conditions: "AGB",
    store_made_in_italy: "Made in Italy",
    store_hero_default_subtitle: "Hochwertige Möbel, für Sie ausgewählt.",
    store_footer_default: "Hochwertige Möbel, Made in Italy.",
    store_months: "Monate",
    store_days: "Tage",
  },
};

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("tk_lang") || "it");

  useEffect(() => {
    localStorage.setItem("tk_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key, params) => {
    let str = translations[lang]?.[key] || translations.it[key] || key;
    if (params && typeof str === "string") {
      Object.entries(params).forEach(([k, v]) => { str = str.replace(new RegExp(`\\{${k}\\}`, "g"), v); });
    }
    return str;
  };
  return (
    <I18nContext.Provider value={{ lang, setLang, t, languages: ["it", "en", "fr", "de"] }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
